import { TranslationString } from '../localization';

export type QuickReplyTemplateServer = {
  _id: string;
  name: string;
  body: string;
  date_updated: string;
};

export type QuickReplyTemplateListResponseServer = {
  templates: QuickReplyTemplateServer[];
};

export type QuickReplyTemplateMutationResponseServer = {
  template: QuickReplyTemplateServer;
};

export enum QuickReplyTemplateErrorCode {
  templateNotFound = 'template_not_found',
  forbidden = 'forbidden'
}

export const mapQuickReplyTemplateErrorCodeToMessage =
  (code: QuickReplyTemplateErrorCode): TranslationString =>
  (t) =>
    t(`quickReplyTemplate.errors.${code}`, {
      ns: 'entities'
    });
